<h5>Add scenario to device</h5>
<div>
    <div class="mb-3">
        <label for="deviceid" class="form-label">Device ID</label>
        <input [(ngModel)]="deviceid" type="text" class="form-control" name="deviceid" disabled>
    </div>
    <div class="mb-3 input-group">
        <button class="btn btn-outline-primary" type="button" (click)="add()">Add scenario</button>
        <select class="form-select" [(ngModel)]="selectedScenario">
            <option value="0" selected>Please select a scenario, and press the 'Add' button to add it.</option>
            <option *ngFor="let item of scenarios[0]; trackBy: trackSelectByMethod" value="{{item.id}}">{{item.name}}</option>
        </select>
    </div>

    <div class="mb-3">

        <div class="card">
            <div class="card-header">
                Assigned scenarios
            </div>
            <div class="card-body">
                <ul class="list-group">
                    <li class="list-group-item" *ngFor="let item of assigedScenarios[0]; trackBy: trackByMethod">
                        <div class="input-group mb-3">
                            <div class="input-group-text">
                                <input class="form-check-input me-1" type="radio" name="startScenarioRadio" value=""
                                    id="startScenario" checked *ngIf="item.auto_start==1" (click)="autoplay(item.scenario_id)">
                                <input class="form-check-input me-1" type="radio" name="startScenarioRadio" value=""
                                    id="startScenario" *ngIf="item.auto_start==0" (click)="autoplay(item.scenario_id)">
                            </div>
                            <input type="text" class="form-control" value="{{item.name}}" disabled>
                            <button class="btn btn-outline-primary" type="button" id="button-addon2"
                                (click)="play(item.scenario_id)">Play</button>
                            <button class="btn btn-outline-danger" type="button" id="button-addon2"
                                (click)="remove(item.scenario_id)">Remove</button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <button (click)="cancel()" class="btn btn-primary">Cancel</button>
</div>